import { BarChart3, Users } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Avatar } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'

type WatchlistAccount = {
  id: string
  username: string
  full_name?: string
  followers?: number
}

export function AccountsList({ accounts }: { accounts: WatchlistAccount[] }) {
  const formatFollowers = (count: number) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`
    return count.toString()
  }

  return (
    <div className="space-y-3">
      <div className="text-sm text-muted-foreground">Accounts in this watchlist</div>
      <div className="space-y-3 max-h-[400px] overflow-y-auto pr-1">
        {accounts.length === 0 && (
          <div className="text-sm text-muted-foreground">No accounts yet.</div>
        )}
        {accounts.map((acc) => {
          const fullName = acc.full_name || acc.username
          const followers = acc.followers || 0
          const initials = (fullName || acc.username || '').slice(0, 2).toUpperCase()
          
          return (
            <Card key={acc.id} className="group hover:shadow-md transition-all duration-200">
              <CardHeader className="pb-3">
                <div className="flex items-start gap-3">
                  <Avatar className="h-10 w-10 flex-shrink-0">
                    <div className="w-full h-full bg-gradient-to-br from-green-400 to-blue-400 flex items-center justify-center text-white text-sm font-semibold">
                      {initials}
                    </div>
                  </Avatar>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div className="text-base font-semibold group-hover:text-primary transition-colors truncate">
                        {fullName}
                      </div>
                      <Badge variant="secondary" className="text-xs bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 shrink-0">
                        Competitor
                      </Badge>
                    </div>
                    <div className="flex items-center gap-1 mt-1 text-sm text-muted-foreground">
                      <Users className="h-3 w-3" />
                      <span className="font-medium">@{acc.username}</span>
                      {followers > 0 && (
                        <span className="text-xs">• {formatFollowers(followers)} followers</span>
                      )}
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="flex gap-2">
                  <Button asChild size="sm" variant="outline" className="flex-1">
                    <a href={`https://instagram.com/${acc.username}`} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  </Button>
                  <Button asChild size="sm" variant="outline" className="flex-1">
                    <Link to={`/instagram/account/${acc.id}`}>
                      <BarChart3 className="mr-2 h-3 w-3" />
                      Analytics
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  )
}


